<script>
import {mapActions} from 'vuex'

export default {
  methods: {
    ...mapActions(['messageAction', 'handleErrorAction']),
    handleError(error) {
      this.handleErrorAction(error)
    },
    showMessage(msg) {
      this.messageAction(msg)
    }
  }
}
</script>